<template>
    <div>
        <div :class="loaderClasses" style="margin: 0;">
          <div :style="checkStyles" class="checkmark draw"></div>
        </div>
    </div>
</template>

<style lang="scss">
    @use "sass:math";

    $brand-success: #5cb85c;
    $loader-size: 10em;
    $check-height: math.div($loader-size, 2);
    $check-width: math.div($check-height, 2);
    $check-left: (math.div($loader-size, 6) + math.div($loader-size,12));
    $check-thickness: 2px;
    $check-color: $brand-success;

    .circle-loader {
      margin: 0 0 30px 10px;
      border: $check-thickness solid rgba(0, 0, 0, 0.2);
      border-left-color: $check-color;
      animation-name: loader-spin;
      animation-duration: 1s;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
      position: relative;
      display: inline-block;
      vertical-align: top;
    }

    .circle-loader,
    .circle-loader:after {
      border-radius: 50%;
      width: $loader-size;
      height: $loader-size;
    }

    .load-complete {
      -webkit-animation: none;
      animation: none;
      border-color: $check-color;
      transition: border 500ms ease-out;
    }

    .checkmark {
      display: none;
      
      &.draw:after {
        animation-duration: 800ms;
        animation-timing-function: ease;
        animation-name: checkmark;
        transform: scaleX(-1) rotate(135deg);
      }
      
      &:after {
        opacity: 1;
        height: $check-height;
        width: $check-width;
        transform-origin: left top;
        border-right: $check-thickness solid $check-color;
        border-top: $check-thickness solid $check-color;
        content: '';
        left: $check-left;
        top: $check-height;
        position: absolute;
      }
    }

    @keyframes loader-spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    @keyframes checkmark {
      0% {
        height: 0;
        width: 0;
        opacity: 1;
      }
      20% {
        height: 0;
        width: $check-width;
        opacity: 1;
      }
      40% {
        height: $check-height;
        width: $check-width;
        opacity: 1;
      }
      100% {
        height: $check-height;
        width: $check-width;
        opacity: 1;
      }
    }
</style>

<script>
    export default {
        props: {
            loaded: {
                default() {
                    return false;
                }
            }
        },
        computed: {
            loaderClasses() {
                return 'circle-loader' + (this.loaded ? ' load-complete' : '');
            },
            checkStyles() {
                 return (this.loaded ? 'display: block;' : '');
            }
        }
    }
</script>